import { UseQueryResult } from '@tanstack/react-query';
import { useSession } from '../SessionProvider';
import { getAllGroups, getShareGroups, Group } from './getGroups';
import { useTrackedQuery as useQuery } from '@ais-ui/performance-tracking';

export const useGetShareGroups = (): UseQueryResult<Group[]> => {
  const { olSession } = useSession();

  return useQuery(['getShareGroups'], () => {
    return getShareGroups(olSession);
  });
};

export const useGetAllGroups = (): UseQueryResult<Group[]> => {
  const { olSession } = useSession();

  return useQuery(['getAllGroups'], () => {
    return getAllGroups(olSession);
  });
};
